import { FILTER, InsightType } from "@/constants";
import CheckboxSelect from "@/containers/Filters/CheckboxSelect";
import FilterCountIndicator from "@/containers/Filters/FilterCountIndicator";
import { FilterOption } from "@/types/FilterOptions";
import { Accordion } from "@components/Accordion";

import useFilterCount from "../../hooks/useFilterCount";
import useOptionLabel from "../../hooks/useOptionLabel";

export type InsightTypeProps = {
  options: FilterOption<InsightType>[];
};

const InsightTypeFilter: React.FunctionComponent<InsightTypeProps> = ({
  options,
}) => {
  const preview = useOptionLabel(FILTER.INSIGHT_TYPES, options);
  const count = useFilterCount(FILTER.INSIGHT_TYPES);

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <Accordion
      value="insights-type"
      data-testid="filter-bar--insight-type"
      preview={preview}
      indicator={<FilterCountIndicator count={count} />}
      title={L.MENTIONS_VIEW_TOOLBAR_FILTER_INSIGHT_TYPES}
    >
      <CheckboxSelect name={FILTER.INSIGHT_TYPES} options={options} />
    </Accordion>
  );
};

export default InsightTypeFilter;
